import { createBootstrap } from "../../bootstrap";

export default createBootstrap(
  "user",
  "institution",
  "fedwireTemplates",
  "wireRecipients",
  "recipients",
);
